<template>
<div>
  <div class="page-header create-item-page-header">
    <div class="add-item d-flex">
      <div class="page-title">
        <h4 class="mb-0">{{ $t('new_item') }}</h4>
      </div>
    </div>

    <ul class="table-top-head align-items-center flex-nowrap create-item-header-actions">
      <!-- Item Type -->
      <li class="item-type-control">
        <div class="item-type-control-inner">
          <span class="item-type-control-label">
            <i class="ti ti-category"></i>
            {{ $t('item_type') }}
          </span>
          <div class="add-product item-type-wrapper">
            <div
              class="dropdown form-basic-dropdown"
              v-on="{
                'show.bs.dropdown': () => setDropdownOpen('item_type', true),
                'hide.bs.dropdown': () => setDropdownOpen('item_type', false),
              }"
            >
              <a
                href="javascript:void(0);"
                class="btn item-type-select-btn d-inline-flex align-items-center w-100"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span class="text-truncate">{{ selectedItemTypeLabel }}</span>
                <i
                  class="ti ms-auto flex-shrink-0"
                  :class="dropdownOpen.item_type ? 'ti-chevron-up' : 'ti-chevron-down'"
                ></i>
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-2 w-100">
                <li v-for="type in item_types" :key="type.id">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    :class="{ active: String(items.item_type) === String(type.id) }"
                    @click.prevent="selectItemType(type)"
                  >
                    {{ type.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </li>

      <!-- Back button -->
      <li>
        <div class="page-btn">
          <router-link to="/items" class="btn btn-added">
            <span>Back</span>
          </router-link>
        </div>
      </li>
    </ul>
  </div>

  <!-- /add -->
  <form @submit.prevent="submitItem" @keydown.enter="handleEnter" enctype="multipart/form-data">
    <div class="card">
      <div class="card-body add-product pb-0">
        <div class="accordion-card-one accordion" id="accordionExample">
          <div class="accordion-item">
            <div class="accordion-header" id="headingOne">
              <div class="accordion-button" >
                <div class="addproduct-icon" >
                  <h5><i class="ti ti-info-circle"></i><span>{{ $t('item_information') }}</span></h5>
<!--                  <a href="javascript:void(0);"><i class="ti ti-chevron-down"></i></a>-->
                </div>
              </div>
            </div>
            <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('item_name') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.item_name"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('item_code') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.item_code"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('category') }} <span class="text-danger">*</span> </label>
                        <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#create-modal2"><i class="ti ti-circle-plus me-1" ></i><span>{{ $t("add_new") }}</span></a>
                      </div>
                      <div
                        class="dropdown form-basic-dropdown"
                        v-on="{
                          'show.bs.dropdown': () => setDropdownOpen('category', true),
                          'hide.bs.dropdown': () => setDropdownOpen('category', false),
                        }"
                      >
                        <a
                          href="javascript:void(0);"
                          class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span class="text-truncate">{{ selectedCategoryLabel }}</span>
                          <i
                            class="ti ms-auto flex-shrink-0"
                            :class="dropdownOpen.category ? 'ti-chevron-up' : 'ti-chevron-down'"
                          ></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                          <li v-for="cat in categories" :key="cat.id">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item rounded-1"
                              @click.prevent="selectCategory(cat)"
                            >
                              {{ cat.node }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="mb-3 add-product">
                        <div class="add-newplus">
                          <label class="form-label">{{ $t('sub_category') }} <span class="text-danger">*</span></label>
                          <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal3" @click="triggerFetchCategoryDetails"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                        </div>
                        <div
                          class="dropdown form-basic-dropdown"
                          v-on="{
                            'show.bs.dropdown': () => setDropdownOpen('sub_category', true),
                            'hide.bs.dropdown': () => setDropdownOpen('sub_category', false),
                          }"
                        >
                          <a
                            href="javascript:void(0);"
                            class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <span class="text-truncate">{{ selectedSubCategoryLabel }}</span>
                            <i
                              class="ti ms-auto flex-shrink-0"
                              :class="dropdownOpen.sub_category ? 'ti-chevron-up' : 'ti-chevron-down'"
                            ></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                            <li v-for="sub in selected_cats_sub_categories" :key="sub.id">
                              <a
                                href="javascript:void(0);"
                                class="dropdown-item rounded-1"
                                @click.prevent="selectSubCategory(sub)"
                              >
                                {{ sub.node }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('brand') }}
                      </label>
                      <input
                        type="text"
                        v-model="items.brand"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                      <div class="mb-3 add-product">
                        <label class="form-label">
                          {{ $t('model_number') }}
                        </label>
                        <input
                          type="text"
                          v-model="items.model_number"
                          class="form-control"
                        />
                      </div>
                    </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <div class="add-newplus">
                        <label class="form-label">{{ $t('unit') }} <span class="text-danger">*</span></label>
                        <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal6"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                      </div>
                      <div
                        class="dropdown form-basic-dropdown"
                        v-on="{
                          'show.bs.dropdown': () => setDropdownOpen('unit', true),
                          'hide.bs.dropdown': () => setDropdownOpen('unit', false),
                        }"
                      >
                        <a
                          href="javascript:void(0);"
                          class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span class="text-truncate">{{ selectedUnitLabel }}</span>
                          <i
                            class="ti ms-auto flex-shrink-0"
                            :class="dropdownOpen.unit ? 'ti-chevron-up' : 'ti-chevron-down'"
                          ></i>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                          <li v-for="unit in units" :key="unit.id">
                            <a
                              href="javascript:void(0);"
                              class="dropdown-item rounded-1"
                              @click.prevent="selectUnit(unit)"
                            >
                              {{ unit.unit }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('reorder_level') }}
                      </label>
                      <input
                        type="text"
                        v-model="items.reorder_level"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="mb-3 add-product">
                      <label class="form-label">
                        {{ $t('barcode_qr_code') }} <span class="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        v-model="items.barcode_qr_code"
                        class="form-control"
                      />
                    </div>
                  </div>

                  <div v-if="!isMultiVariant" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <label class="form-label">{{ $t('discount') }}</label>
                    <input
                      type="text"
                      v-model="items.discount"
                      class="form-control"
                    />
                  </div>

                  <div class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <label class="form-label">{{ $t('vat_group') }} <span class="text-danger">*</span></label>
                    <div
                      class="dropdown form-basic-dropdown"
                      v-on="{
                        'show.bs.dropdown': () => setDropdownOpen('vat_group', true),
                        'hide.bs.dropdown': () => setDropdownOpen('vat_group', false),
                      }"
                    >
                      <a
                        href="javascript:void(0);"
                        class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <span class="text-truncate">{{ selectedVatGroupLabel }}</span>
                        <i
                          class="ti ms-auto flex-shrink-0"
                          :class="dropdownOpen.vat_group ? 'ti-chevron-up' : 'ti-chevron-down'"
                        ></i>
                      </a>
                      <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                        <li v-for="group in vat_groups" :key="group.id">
                          <a
                            href="javascript:void(0);"
                            class="dropdown-item rounded-1"
                            @click.prevent="selectVatGroup(group)"
                          >
                            {{ group.vat_group_name }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div v-if="!isMultiVariant && !isWarrantyItemType" class="col-lg-3 col-md-3 col-sm-3 col-12">
                    <label class="form-label">{{ $t('selling_price') }} <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="items.selling_price"
                      class="form-control"
                    />
                  </div>
                </div>

                <!-- Opening stock: switch + related fields (NO_VARIANT / MULTI_VARIANT) -->
                <div
                  v-if="showStockSection"
                  class="stock-fields-panel mb-3"
                  :class="{ 'is-open': items.with_stock }"
                >
                  <div class="stock-fields-panel-header optional-panel-header">
                    <div class="optional-panel-controls">
                      <div class="stock-fields-panel-title">
                        <i class="ti ti-packages"></i>
                        <span>{{ $t('item_with_stock') }}</span>
                      </div>
                      <div class="form-check form-switch mb-0 d-flex align-items-center flex-shrink-0">
                        <input
                          class="form-check-input me-2"
                          type="checkbox"
                          id="stockToggle"
                          v-model="withStockModel"
                        />
                        <span
                          class="warranty-add-variant-state"
                          :class="items.with_stock ? 'is-yes' : 'is-no'"
                        >
                          {{ items.with_stock ? $t('Yes') : $t('No') }}
                        </span>
                      </div>
                      <span class="optional-panel-badge">{{ $t('optional') }}</span>
                    </div>
                    <div class="optional-panel-hint">
                      <i class="ti ti-info-circle"></i>
                      <span>
                        {{ $t('add_stock_optional_hint_before') }}
                        <strong>{{ $t('add_stock_optional_hint_path') }}</strong>
                        {{ $t('add_stock_optional_hint_after') }}
                      </span>
                    </div>
                  </div>

                  <div v-if="items.with_stock" class="stock-fields-panel-body">
                    <div class="row">
                      <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <div class="add-newplus">
                            <label class="form-label">{{ $t('warehouse') }} <span class="text-danger">*</span></label>
                            <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal1" @click="openModal"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                          </div>
                          <div
                            class="dropdown form-basic-dropdown"
                            v-on="{
                              'show.bs.dropdown': () => setDropdownOpen('warehouse', true),
                              'hide.bs.dropdown': () => setDropdownOpen('warehouse', false),
                            }"
                          >
                            <a
                              href="javascript:void(0);"
                              class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <span class="text-truncate">{{ selectedWarehouseLabel }}</span>
                              <i
                                class="ti ms-auto flex-shrink-0"
                                :class="dropdownOpen.warehouse ? 'ti-chevron-up' : 'ti-chevron-down'"
                              ></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                              <li v-for="warehouse in warehouses" :key="warehouse.id">
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1"
                                  @click.prevent="selectWarehouse(warehouse)"
                                >
                                  {{ warehouse.name }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <div class="add-newplus">
                            <label class="form-label">{{ $t('supplier_name') }} <span class="text-danger">*</span></label>
                            <a href="#" data-bs-toggle="modal" data-bs-target="#create-modal7"><i class="ti ti-circle-plus me-1"></i><span>{{ $t("add_new") }}</span></a>
                          </div>
                          <div
                            class="dropdown form-basic-dropdown"
                            v-on="{
                              'show.bs.dropdown': () => setDropdownOpen('supplier_name', true),
                              'hide.bs.dropdown': () => setDropdownOpen('supplier_name', false),
                            }"
                          >
                            <a
                              href="javascript:void(0);"
                              class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <span class="text-truncate">{{ selectedSupplierLabel }}</span>
                              <i
                                class="ti ms-auto flex-shrink-0"
                                :class="dropdownOpen.supplier_name ? 'ti-chevron-up' : 'ti-chevron-down'"
                              ></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                              <li v-for="supplier in suppliers" :key="supplier.id">
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1"
                                  @click.prevent="selectSupplier(supplier)"
                                >
                                  {{ supplier.name }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="mb-3 position-relative">
                          <label class="form-label fw-semibold">{{ $t('manufacturing_date') }}</label>
                          <div class="input-group">
                            <span class="input-group-text bg-white border-end-0">
                              <i class="ti ti-calendar text-secondary"></i>
                            </span>
                            <input
                              type="date"
                              v-model="items.manufacturing_date"
                              :format="'yyyy-MM-dd'"
                              class="form-control border-start-0"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="mb-3 position-relative">
                          <label class="form-label fw-semibold">{{ $t('expire_date') }}</label>
                          <div class="input-group">
                            <span class="input-group-text bg-white border-end-0">
                              <i class="ti ti-calendar text-secondary"></i>
                            </span>
                            <input
                              type="date"
                              v-model="items.expire_date"
                              :format="'yyyy-MM-dd'"
                              class="form-control border-start-0"
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="!isMultiVariant"
                        class="col-lg-3 col-md-3 col-sm-6 col-12"
                      >
                        <div class="mb-3">
                          <label class="form-label">{{ $t('purchase_price') }} <span class="text-danger">*</span></label>
                          <input
                            type="text"
                            v-model="items.purchase_price"
                            class="form-control"
                          />
                        </div>
                      </div>

                      <div
                        v-if="!isMultiVariant"
                        class="col-lg-3 col-md-3 col-sm-6 col-12"
                      >
                        <div class="mb-3">
                          <label class="form-label">{{ $t('stock_quantity') }} <span class="text-danger">*</span></label>
                          <input
                            type="text"
                            v-model="items.stock_quantity"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="showVariantBuilder"
                  class="stock-fields-panel mb-3 mt-3"
                  :class="{ 'is-open': add_variant }"
                >
                  <div class="stock-fields-panel-header optional-panel-header">
                    <div class="optional-panel-controls">
                      <div class="stock-fields-panel-title">
                        <i class="ti ti-versions"></i>
                        <span>{{ $t('add_variant') }}</span>
                      </div>
                      <div class="form-check form-switch mb-0 d-flex align-items-center flex-shrink-0">
                        <input
                          class="form-check-input me-2"
                          type="checkbox"
                          id="addVariantToggle"
                          v-model="add_variant"
                          :disabled="isMultiVariant && items.with_stock"
                        />
                        <span
                          class="warranty-add-variant-state"
                          :class="add_variant ? 'is-yes' : 'is-no'"
                        >
                          {{ add_variant ? $t('Yes') : $t('No') }}
                        </span>
                      </div>
                      <span class="optional-panel-badge">{{ $t('optional') }}</span>
                    </div>
                    <div class="optional-panel-hint">
                      <i class="ti ti-info-circle"></i>
                      <span v-if="isWarrantyItemType">
                        {{ $t('add_warranty_variant_optional_hint_before') }}
                        <strong>{{ $t('Yes') }}</strong>
                        {{ $t('add_warranty_variant_optional_hint_middle') }}
                        <strong>{{ $t('add_warranty_variant_optional_hint_path') }}</strong>
                        {{ $t('add_warranty_variant_optional_hint_after') }}
                      </span>
                      <span v-else>
                        {{ $t('add_variant_optional_hint_before') }}
                        <strong>{{ $t('add_variant_optional_hint_path') }}</strong>
                        {{ $t('add_variant_optional_hint_after') }}
                      </span>
                    </div>
                  </div>

                  <div v-if="showVariantFields" class="stock-fields-panel-body">
                    <!-- attribute selector -->
                    <div class="row align-items-end variant-attr-row">
                      <div class="col-lg-3 col-md-3 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <div class="add-newplus">
                            <label class="form-label">Attribute</label>
                            <a
                              href="javascript:void(0);"
                              data-bs-toggle="modal"
                              data-bs-target="#create-modal8"
                            >
                              <i class="ti ti-circle-plus me-1"></i>
                              <span>{{ $t("add_new") }}</span>
                            </a>
                          </div>
                          <div
                            class="dropdown form-basic-dropdown"
                            v-on="{
                              'show.bs.dropdown': () => setDropdownOpen('attribute', true),
                              'hide.bs.dropdown': () => setDropdownOpen('attribute', false),
                            }"
                          >
                            <a
                              href="javascript:void(0);"
                              class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <span class="text-truncate">{{ selectedAttributeLabel }}</span>
                              <i
                                class="ti ms-auto flex-shrink-0"
                                :class="dropdownOpen.attribute ? 'ti-chevron-up' : 'ti-chevron-down'"
                              ></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                              <li v-for="attr in availableAttributes" :key="attr.id">
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1"
                                  @click.prevent="selectAttribute(attr)"
                                >
                                  {{ attr.name }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="mb-3 add-product">
                          <div class="add-newplus">
                            <label class="form-label">Attribute Values</label>
                            <a
                              href="javascript:void(0);"
                              @click="openAttributeValueModal"
                            >
                              <i class="ti ti-circle-plus me-1"></i>
                              <span>{{ $t("add_new") }}</span>
                            </a>
                          </div>
                          <div
                            class="dropdown form-basic-dropdown attribute-values-dropdown"
                            v-on="{
                              'show.bs.dropdown': () => setDropdownOpen('attribute_values', true),
                              'hide.bs.dropdown': () => setDropdownOpen('attribute_values', false),
                            }"
                          >
                            <a
                              href="javascript:void(0);"
                              class="btn btn-white btn-md d-inline-flex align-items-center w-100"
                              data-bs-toggle="dropdown"
                              data-bs-auto-close="outside"
                              aria-expanded="false"
                            >
                              <span class="text-truncate">{{ selectedAttributeValuesLabel }}</span>
                              <i
                                class="ti ms-auto flex-shrink-0"
                                :class="dropdownOpen.attribute_values ? 'ti-chevron-up' : 'ti-chevron-down'"
                              ></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end p-3 w-100">
                              <li v-for="val in selected_attribute_values" :key="val.id">
                                <a
                                  href="javascript:void(0);"
                                  class="dropdown-item rounded-1 d-flex align-items-center justify-content-between"
                                  :class="{ active: isAttributeValueSelected(val.id) }"
                                  @click.prevent="toggleAttributeValue(val)"
                                >
                                  <span>{{ val.value }}</span>
                                  <i
                                    v-if="isAttributeValueSelected(val.id)"
                                    class="ti ti-check ms-2"
                                  ></i>
                                </a>
                              </li>
                              <li v-if="!selected_attribute_values.length">
                                <span class="dropdown-item-text text-muted">
                                  {{ $t('select_an_option') }}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                        <div class="mb-3">
                          <label class="form-label d-none d-md-block">&nbsp;</label>
                          <button type="button" class="btn btn-primary w-100" @click="addVariantGroup">
                            Add Attribute Set
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- groups -->
                    <div v-if="variant_groups.length" class="mt-3">
                      <h6>Attribute Groups</h6>

                      <ul class="list-group">
                        <li
                          v-for="(g, i) in variant_groups"
                          :key="i"
                          class="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <div class="d-flex flex-wrap align-items-center gap-1">
                            <b class="me-1">{{ g.attribute_name }}:</b>
                            <span
                              v-for="v in g.values"
                              :key="v.id"
                              class="variant-value-badge"
                            >
                              {{ v.value }}
                            </span>
                          </div>

                          <button
                            type="button"
                            class="btn btn-sm btn-danger ms-2"
                            @click="removeVariantGroup(i)"
                          >
                            Delete
                          </button>
                        </li>
                      </ul>

                      <div class="row mt-2 variant-generate-row">
                        <div class="col-lg-9 col-md-9 d-none d-md-block"></div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                          <button type="button" class="btn btn-success w-100" @click="generateVariants">
                            Generate Variants
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- variants table -->
                    <div class="generated-variants-panel mt-3">
                      <div class="generated-variants-header">
                        <h6 class="mb-0">Generated Variants</h6>
                        <span class="generated-variants-count">
                          {{ items.variants?.length || 0 }}
                        </span>
                      </div>

                      <div class="generated-variants-table-wrap">
                        <table class="table align-middle mb-0 generated-variants-table">
                          <thead>
                            <tr>
                              <th>{{ $t('item_name') }}</th>
                              <th>{{ $t('barcode') }} <span class="text-danger">*</span></th>
                              <th>{{ $t('variant') }}</th>
                              <th>SKU</th>
                              <th v-if="!isWarrantyItemType">
                                {{ $t('stock_quantity') }}
                                <span v-if="items.with_stock" class="text-danger">*</span>
                              </th>
                              <th v-if="!isWarrantyItemType">
                                {{ $t('purchase_price') }}
                                <span v-if="items.with_stock" class="text-danger">*</span>
                              </th>
                              <th>{{ $t('selling_price') }} <span class="text-danger">*</span></th>
                              <th>{{ $t('discount') }}</th>
                              <th>{{ $t('variant_image') }}</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr v-if="!items.variants || !items.variants.length">
                              <td :colspan="isWarrantyItemType ? 7 : 9" class="generated-variants-empty">
                                Generate variants to see them here
                              </td>
                            </tr>

                            <tr
                              v-for="(variant, index) in items.variants"
                              :key="index"
                            >
                              <td>
                                <span class="cell-ellipsis" :title="variant.item_name">
                                  {{ variant.item_name }}
                                </span>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="form-control form-control-sm variant-input"
                                  v-model="variant.barcode"
                                />
                              </td>

                              <td>
                                <span
                                  class="cell-ellipsis"
                                  :title="formatVariantAttributes(variant.attributes)"
                                >
                                  {{ formatVariantAttributes(variant.attributes) }}
                                </span>
                              </td>

                              <td>
                                <span class="cell-ellipsis" :title="variant.sku">
                                  {{ variant.sku }}
                                </span>
                              </td>
                              <td v-if="!isWarrantyItemType">
                                <input
                                  type="number"
                                  class="form-control form-control-sm variant-input variant-input-number"
                                  v-model.number="variant.stock"
                                  min="0"
                                  :disabled="!items.with_stock"
                                  :readonly="!items.with_stock"
                                />
                              </td>

                              <td v-if="!isWarrantyItemType">
                                <input
                                  type="number"
                                  class="form-control form-control-sm variant-input variant-input-number"
                                  v-model.number="variant.purchase_price"
                                  step="0.01"
                                  min="0"
                                  :disabled="!items.with_stock"
                                  :readonly="!items.with_stock"
                                />
                              </td>

                              <td>
                                <input
                                  type="number"
                                  class="form-control form-control-sm variant-input variant-input-number"
                                  v-model.number="variant.selling_price"
                                  step="0.01"
                                  min="0"
                                />
                              </td>

                              <td>
                                <input
                                  type="number"
                                  class="form-control form-control-sm variant-input variant-input-number"
                                  v-model.number="variant.discount"
                                  step="0.01"
                                  min="0"
                                />
                              </td>

                              <td>
                                <VariantImageUpload
                                  :src="variant.image_preview || ''"
                                  :size="44"
                                  @select="(file) => setVariantImage(variant, file)"
                                  @remove="removeVariantImage(variant)"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion-card-one accordion" id="accordionExample3">
          <div class="accordion-item">
            <div class="accordion-header" id="headingThree">
              <div class="accordion-button">
                <div class="addproduct-icon list">
                  <h5><i class="ti ti-photo-plus"></i><span>{{ $t('images') }}</span></h5>
<!--                  <a href="javascript:void(0);"><i class="ti ti-chevron-down"></i></a>-->
                </div>
              </div>
            </div>
            <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree" data-bs-parent="#accordionExample3">
              <div class="accordion-body">
                <div class="text-editor add-list add">
                  <div class="col-lg-12">
                    <div class="add-choosen">
                      <div class="input-blocks">
                        <div class="image-upload position-relative" style="width: 220px; height: 120px;">
                          <input
                            type="file"
                            class="form-control d-none"
                            id="imageUploadInput"
                            name="images"
                            @change="imageUpload"
                            accept="image/*"
                            multiple
                          />

                          <!-- Fixed-size upload box -->
                          <label
                            for="imageUploadInput"
                            class="d-flex flex-column align-items-center justify-content-center border border-primary rounded text-primary w-100 h-100"
                            style="cursor: pointer;"
                          >
                            <i class="ti ti-upload fs-1 mb-2"></i>
                            <h4 class="mb-0">{{ $t('add_images') }}</h4>
                          </label>
                        </div>
                      </div>

                      <div class="phone-img" v-for="(preview, index) in imagePreview" :key="index">
                        <img :src="preview" alt="image">
                        <a href="javascript:void(0);" @click="removeImage(index);"><i class="ti ti-x"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <div class="btn-addproduct mb-4">
        <button type="button" class="btn btn-cancel me-2" @click="cancelForm">{{ $t('cancel') }}</button>
        <button type="submit" class="btn btn-submit" @click="onSubmit">{{ $t('submit') }}</button>
      </div>
    </div>
  </form>

  <!-- /add -->
  <CreateWarehouseModal
    id="create-modal1" @create_success="fetchWarehouse"
  />

  <CreateCategoryModal
    id="create-modal2" @create_success="fetchCategory"
  />

  <CreateSubCategoryModal
    id="create-modal3"
    ref="createSubCategoryModal"
    :category="items.category"
    @create_success="fetchCatSubCategories"
  />

  <CreateSizeModal
    id="create-modal4" @create_success="fetchSize"
  />

  <CreateColorModal
    id="create-modal5" @create_success="fetchColor"
  />

  <CreateUnitModal
    id="create-modal6" @create_success="fetchUnit"
  />

  <CreateSupplierModal
    id="create-modal7" @create_success="fetchSupplier"
  />

  <CreateAttributeModal
    id="create-modal8" @create_success="fetchAttribute"
  />

  <CreateAttributeValueModal
    id="create-modal9"
    :attribute-id="items.attribute"
    @create_success="fetchAttributeValue"
  />
</div>
</template>

<script>
import Modal from "@/components/common/Modal.vue";
import apiUrls from "@/urls";
import Vue3Datepicker from 'vue3-datepicker';
import CreateWarehouseModal from "@/views/admin_dashboard/item/CreateWarehouseModal.vue";
import CreateCategoryModal from "@/views/admin_dashboard/item/CreateCategoryModal.vue";
import CreateSubCategoryModal from "@/views/admin_dashboard/item/CreateSubCategoryModal.vue";
import CreateSizeModal from "@/views/admin_dashboard/item/CreateSizeModal.vue";
import CreateColorModal from "@/views/admin_dashboard/item/CreateColorModal.vue";
import CreateUnitModal from "@/views/admin_dashboard/item/CreateUnitModal.vue";
import CreateSupplierModal from "@/views/admin_dashboard/item/CreateSupplierModal.vue";
import CreateAttributeModal from "@/views/admin_dashboard/item/CreateAttributeModal.vue";
import CreateAttributeValueModal from "@/views/admin_dashboard/item/CreateAttributeValueModal.vue";
import {useToast} from "vue-toastification";
import VariantImageUpload from "@/components/common/VariantImageUpload.vue";

export default {
  components: {
    VariantImageUpload,
    CreateCategoryModal,
    Modal,
    Vue3Datepicker,
    CreateWarehouseModal,
    CreateSubCategoryModal,
    CreateSizeModal,
    CreateColorModal,
    CreateUnitModal,
    CreateSupplierModal,
    CreateAttributeModal,
    CreateAttributeValueModal
  },

  emits: ['select'],

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      dropdownOpen: {
        item_type: false,
        category: false,
        sub_category: false,
        unit: false,
        vat_group: false,
        warehouse: false,
        supplier_name: false,
        attribute: false,
        attribute_values: false,
      },
      items: {
        with_stock: false, item_code: '', item_name: '', sku: '', category: null, sub_category: null, size: null,
        color: null, brand: '', model_number: '',
        warehouse: null, stock_quantity: '', unit: null, reorder_level: 0, manufacturing_date: null, expire_date: null,
        item_serial_number: '', barcode_qr_code: '', supplier_name: null, purchase_price: '', selling_price: 0,
        discount: 0, vat_group: null, images: [], item_type: '', attribute: null, attribute_values: [], variants: []
      },
      previous_with_stock: false,
      categories: [],
      sub_categories: [],
      sizes: [],
      colors: [],
      warehouses: [],
      units: [],
      suppliers: [],
      errors: {},
      selected_cats_sub_categories: [],
      imagePreview: [],
      vat_groups: [],
      item_types: [],
      attributes: [],
      selected_attribute_values: [],
      variants: [],
      variant_groups: [],
      add_variant: false,
    };
  },

  mounted() {
    this.fetchDropdownData();
  },

  computed: {
    selectedCategoryLabel() {
      if (!this.items.category) {
        return this.$t('select_an_option');
      }
      const cat = this.categories.find(
        (c) => String(c.id) === String(this.items.category)
      );
      return cat ? cat.node : this.$t('select_an_option');
    },

    selectedSubCategoryLabel() {
      if (!this.items.sub_category) {
        return this.$t('select_an_option');
      }
      const sub = this.selected_cats_sub_categories.find(
        (s) => String(s.id) === String(this.items.sub_category)
      );
      return sub ? sub.node : this.$t('select_an_option');
    },

    selectedItemTypeLabel() {
      if (!this.items.item_type && this.items.item_type !== 0) {
        return this.$t('select_an_option');
      }
      const type = this.item_types.find(
        (t) => String(t.id) === String(this.items.item_type)
      );
      return type ? type.name : this.$t('select_an_option');
    },

    selectedUnitLabel() {
      if (!this.items.unit) {
        return this.$t('select_an_option');
      }
      const unit = this.units.find(
        (u) => String(u.id) === String(this.items.unit)
      );
      return unit ? unit.unit : this.$t('select_an_option');
    },

    selectedVatGroupLabel() {
      if (this.items.vat_group === null || this.items.vat_group === undefined || this.items.vat_group === '') {
        return this.$t('select_an_option');
      }
      const group = this.vat_groups.find(
        (g) => String(g.id) === String(this.items.vat_group)
      );
      return group ? group.vat_group_name : this.$t('select_an_option');
    },

    selectedWarehouseLabel() {
      if (!this.items.warehouse) {
        return this.$t('select_an_option');
      }
      const warehouse = this.warehouses.find(
        (w) => String(w.id) === String(this.items.warehouse)
      );
      return warehouse ? warehouse.name : this.$t('select_an_option');
    },

    selectedSupplierLabel() {
      if (!this.items.supplier_name) {
        return this.$t('select_an_option');
      }
      const supplier = this.suppliers.find(
        (s) => String(s.id) === String(this.items.supplier_name)
      );
      return supplier ? supplier.name : this.$t('select_an_option');
    },

    selectedAttributeLabel() {
      if (!this.items.attribute) {
        return this.$t('select_an_option');
      }
      const attr = this.attributes.find(
        (a) => String(a.id) === String(this.items.attribute)
      );
      return attr ? attr.name : this.$t('select_an_option');
    },

    selectedAttributeValuesLabel() {
      const selectedIds = (this.items.attribute_values || []).map(Number);
      if (!selectedIds.length) {
        return this.$t('select_an_option');
      }
      const labels = this.selected_attribute_values
        .filter((v) => selectedIds.includes(Number(v.id)))
        .map((v) => v.value);
      return labels.length ? labels.join(', ') : this.$t('select_an_option');
    },

    formattedsizes() {
      return this.sizes.map(size => ({ id: size.id, text: size.size }));
    },

    formattedcolors() {
      return this.colors.map(color => ({ id: color.id, text: color.color }));
    },

    isDefaultItemType() {
      const selectedType = this.item_types.find(
        item => Number(item.id) === Number(this.items.item_type)
      );

      return ["NO_VARIANT", "MULTI_VARIANT"].includes(selectedType?.code);
    },

    // Stock switch + related fields for no-variant / multi-variant only
    showStockSection() {
      return this.isDefaultItemType;
    },

    withStockModel: {
      get() {
        return this.items.with_stock;
      },
      set(val) {
        // only allow change when default type
        if (this.isDefaultItemType) {
          this.items.with_stock = val;
          this.previous_with_stock = val;
        }
      }
    },

    availableAttributes() {
      const usedIds = this.variant_groups.map(g => Number(g.attribute_id));
      return this.attributes.filter(item => !usedIds.includes(Number(item.id)));
    },

    isMultiVariant() {
      const itemTypeId = Number(
        this.items.item_type?.id ?? this.items.item_type ?? 0
      );

      const selected = this.item_types.find(
        x => Number(x.id) === itemTypeId
      );

      return (
        selected?.code === "MULTI_VARIANT"
      );
    },

    isWarrantyItemType() {
      const itemTypeId = Number(
        this.items.item_type?.id ?? this.items.item_type ?? 0
      );
      const selected = this.item_types.find(
        x => Number(x.id) === itemTypeId
      );
      return selected?.code === "WARRANTY";
    },

    showStockOnly() {
      return this.items.with_stock === true && !this.isMultiVariant;
    },

    showMultiVariantStock() {
      return this.items.with_stock === true && this.isMultiVariant;
    },

    // MULTI_VARIANT / WARRANTY: show "Add Variant ?" panel (default No)
    showVariantBuilder() {
      return this.isMultiVariant || this.isWarrantyItemType;
    },

    // Attribute + generate only when "Add Variant ?" is Yes
    showVariantFields() {
      return this.add_variant && (this.isMultiVariant || this.isWarrantyItemType);
    },
  },

  watch: {
    add_variant(enabled) {
      // Stock=Yes on multi-variant forces variants on
      if (!enabled && this.isMultiVariant && this.items.with_stock) {
        this.$nextTick(() => {
          this.add_variant = true;
        });
        return;
      }
      if (!enabled) {
        this.clearVariantBuilderState();
      }
    },

    isWarrantyItemType(isWarranty) {
      if (!isWarranty && !this.isMultiVariant) {
        this.add_variant = false;
      }
    },

    isMultiVariant(isMulti) {
      if (!isMulti && !this.isWarrantyItemType) {
        this.add_variant = false;
      } else if (isMulti && this.items.with_stock) {
        this.add_variant = true;
      }
    },

    'items.with_stock'(enabled) {
      if (enabled) {
        // Multi-variant with stock requires variants
        if (this.isMultiVariant) {
          this.add_variant = true;
        }
      } else {
        this.items.stock_quantity = 0;
        this.items.warehouse = null;
        this.items.manufacturing_date = null;
        this.items.expire_date = null;
        this.items.item_serial_number = null;
        this.items.supplier_name = null;
        this.items.purchase_price = 0;
        // Multi-variant: stock is locked to 0 when Add Stock = No
        if (this.isMultiVariant && Array.isArray(this.items.variants)) {
          this.items.variants.forEach((v) => {
            v.stock = 0;
          });
        }
        // Variant switch is independent again when stock is No
      }
    },

    'items.item_type'(newVal) {

      const selectedType = this.item_types.find(
        item => Number(item.id) === Number(newVal)
      );

      const isDefault =
        selectedType?.code === 'NO_VARIANT' ||
        selectedType?.code === 'MULTI_VARIANT';

      if (!isDefault) {
        // store and force off
        this.previous_with_stock = this.items.with_stock;
        this.items.with_stock = false;
      } else {
        // restore
        this.items.with_stock = this.previous_with_stock ?? false;
      }
    },

    'items.attribute': function () {
      this.items.attribute_values = [];
      this.items.variants = [];
    },

  },

  methods: {
      async fetchDropdownData() {
        try {
          const [
            categoriesRes, sub_categoriesRes, sizeRes, colorRes,
            warehouseRes, unitRes, supplierRes, vat_groupRes, item_typesRes, attributeRes
          ] = await Promise.all([
            this.$axios.get(apiUrls.categories.get),
            this.$axios.get(apiUrls.sub_categories.get),
            this.$axios.get(apiUrls.item_size.get),
            this.$axios.get(apiUrls.item_color.get),
            this.$axios.get(apiUrls.inventory_warehouse.get),
            this.$axios.get(apiUrls.measurement_unit.get),
            this.$axios.get(apiUrls.inventory_supplier.get),
            this.$axios.get(apiUrls.vat_group.get),
            this.$axios.get(apiUrls.item_type.get),
            this.$axios.get(apiUrls.attribute.get)
          ]);

          this.categories = categoriesRes?.data || [];
          this.sub_categories = sub_categoriesRes?.data || [];
          this.sizes = sizeRes?.data || [];
          this.colors = colorRes?.data || [];
          this.warehouses = warehouseRes?.data || [];
          this.units = unitRes?.data || [];
          this.suppliers = supplierRes?.data || [];
          this.vat_groups = vat_groupRes?.data || [];
          this.item_types = item_typesRes?.data || [];
          this.attributes = attributeRes?.data || [];

          if (this.item_types.length > 0) {
            this.items.item_type = this.item_types[0].id;
          }

        } catch (error) {
          console.error('Error loading dropdown data:', error);
        }
      },

      handleAttributeSelect(selected) {
        this.items.attribute = Number(selected.id);

        this.items.attribute_values = [];
        this.items.variants = [];

        const attribute = this.attributes.find(
          x => Number(x.id) === Number(selected.id)
        );

        this.selected_attribute_values = (attribute?.values || []).map(v => ({
          id: Number(v.id),
          value: v.value
        }));
      },

      addVariantGroup() {
        const attribute = this.attributes.find(
          x => Number(x.id) === Number(this.items.attribute)
        );

        if (!attribute || !this.items.attribute_values.length) return;

        const alreadyAdded = this.variant_groups.some(
          g => Number(g.attribute_id) === Number(attribute.id)
        );

        if (alreadyAdded) {
          this.toast.error(`${attribute.name} is already added`);
          return;
        }

        const selectedIds = this.items.attribute_values.map(Number);

        const values = this.selected_attribute_values.filter(v =>
          selectedIds.includes(Number(v.id))
        );

        // store group instead of generating variants immediately
        this.variant_groups.push({
          attribute_id: attribute.id,
          attribute_name: attribute.name,
          values: values.map(v => ({
            id: v.id,
            value: v.value
          }))
        });

        // Clear generated variants so they stay in sync with groups
        this.items.variants = [];

        // reset selection after adding
        this.items.attribute = null;
        this.items.attribute_values = [];
        this.selected_attribute_values = [];
      },

      generateVariants() {
        if (!this.variant_groups.length) return;

        let combinations = [[]];

        this.variant_groups.forEach(group => {
          const temp = [];

          group.values.forEach(val => {
            combinations.forEach(existing => {
              temp.push([
                ...existing,
                {
                  attribute_id: group.attribute_id,
                  attribute: group.attribute_name,

                  attribute_value_id: val.id,
                  value: val.value,
                }
              ]);
            });
          });

          combinations = temp;
        });

        // base barcode
        const baseBarcode = this.items.barcode_qr_code || '00000';

        let counter = 1;

        // Keep photos already picked for variants that survive regeneration.
        const previousImages = new Map();
        (this.items.variants || []).forEach((variant) => {
          if (variant.image_file) {
            previousImages.set(this.variantAttributeKey(variant.attributes), variant);
          }
        });

        this.items.variants = combinations.map(combo => {
          const sku = combo.map(c => c.value).join('-');
          const previous = previousImages.get(this.variantAttributeKey(combo));
          previousImages.delete(this.variantAttributeKey(combo));

          return {
            item_name: this.items.item_name,
            barcode: `${baseBarcode}-${counter++}`,
            attributes: combo,
            sku: `${this.items.item_name || ''}-${sku}`,
            stock: this.items.with_stock ? Number(previous?.stock || 0) : 0,
            purchase_price: previous?.purchase_price ?? 0,
            selling_price: previous?.selling_price ?? 0,
            discount: previous?.discount ?? 0,
            image_file: previous?.image_file || null,
            image_preview: previous?.image_preview || '',
          };
        });

        previousImages.forEach((variant) => URL.revokeObjectURL(variant.image_preview));
      },

      variantAttributeKey(attributes) {
        return (attributes || [])
          .map((a) => a.attribute_value_id)
          .sort((a, b) => a - b)
          .join('-');
      },

      setVariantImage(variant, file) {
        if (variant.image_preview) URL.revokeObjectURL(variant.image_preview);
        variant.image_file = file;
        variant.image_preview = URL.createObjectURL(file);
      },

      removeVariantImage(variant) {
        if (variant.image_preview) URL.revokeObjectURL(variant.image_preview);
        variant.image_file = null;
        variant.image_preview = '';
      },

      formatVariantAttributes(attributes) {
        if (!attributes?.length) return '-';
        return attributes
          .map((a) => `${a.attribute}: ${a.value}`)
          .join(' | ');
      },

      onChange(value) {
        this.items.category = value;

        // Filter sub-categories based on selected category
        this.$emit('select', value);
      },

      fetchCategory(newCat) {
        this.categories.push(newCat);

        this.$nextTick(() => {
          this.selectCategory(newCat);
        });
      },

      fetchWarehouse(newWarehouse) {
        this.warehouses.push(newWarehouse);

        this.$nextTick(() => {
          this.selectWarehouse(newWarehouse);
        });
      },

      fetchSize(newSize) {
        this.sizes.push(newSize);

        this.$nextTick(() => {
          this.items.size = newSize.id;
        });
      },

      fetchColor(newColor) {
        this.colors.push(newColor);

        this.$nextTick(() => {
          this.items.color = newColor.id;
        });
      },

      fetchUnit(newUnit) {
        this.units.push(newUnit);

        this.$nextTick(() => {
          this.selectUnit(newUnit);
        });
      },

      fetchSupplier(newSupplier) {
        this.suppliers.push(newSupplier);

        this.$nextTick(() => {
          this.selectSupplier(newSupplier);
        });
      },

      async fetchAttribute(newAttr) {
        if (!newAttr) return;

        const exists = this.attributes.some(
          (a) => String(a.id) === String(newAttr.id)
        );
        if (!exists) {
          this.attributes.push({
            ...newAttr,
            values: newAttr.values || [],
          });
        }

        this.$nextTick(() => {
          this.selectAttribute(newAttr);
        });
      },

      openAttributeValueModal() {
        if (!this.items.attribute) {
          this.toast.error("Please select an attribute first");
          return;
        }

        const modalEl = document.getElementById("create-modal9");
        if (!modalEl) return;

        const modalInstance =
          bootstrap.Modal.getInstance(modalEl) ||
          new bootstrap.Modal(modalEl);
        modalInstance.show();
      },

      async fetchAttributeValue(payload) {
        const attributeId = payload?.attributeId || this.items.attribute;
        if (!attributeId) return;

        try {
          const res = await this.$axios.get(apiUrls.attribute.get);
          this.attributes = res.data || [];

          const attribute = this.attributes.find(
            (a) => Number(a.id) === Number(attributeId)
          );
          if (!attribute) return;

          this.selected_attribute_values = (attribute.values || []).map((v) => ({
            id: Number(v.id),
            value: v.value,
          }));

          const createdNames = (payload?.created || []).map((n) =>
            String(n).toLowerCase()
          );
          const newIds = this.selected_attribute_values
            .filter((v) => createdNames.includes(String(v.value).toLowerCase()))
            .map((v) => Number(v.id));

          const current = (this.items.attribute_values || []).map(Number);
          this.items.attribute_values = [...new Set([...current, ...newIds])];
        } catch (error) {
          console.error("Error refreshing attribute values:", error);
        }
      },

      setDropdownOpen(key, isOpen) {
        this.dropdownOpen[key] = isOpen;
      },

      clearVariantBuilderState() {
        this.variant_groups = [];
        this.items.variants = [];
        this.items.attribute = null;
        this.items.attribute_values = [];
        this.selected_attribute_values = [];
      },

      selectItemType(type) {
        this.items.item_type = type?.id ?? null;
        // Default Off for each type change; user opts in per item
        this.add_variant = false;
        this.clearVariantBuilderState();
      },

      selectCategory(cat) {
        this.items.sub_category = null;
        this.selected_cats_sub_categories = [];

        if (!cat) {
          this.items.category = null;
          return;
        }

        this.items.category = cat.id;
        this.fetchCatSubCategories(cat.id);
      },

      selectSubCategory(sub) {
        this.items.sub_category = sub?.id ?? null;
      },

      selectUnit(unit) {
        this.items.unit = unit?.id ?? null;
      },

      selectVatGroup(group) {
        this.items.vat_group = group?.id ?? null;
      },

      selectWarehouse(warehouse) {
        this.items.warehouse = warehouse?.id ?? null;
      },

      selectSupplier(supplier) {
        this.items.supplier_name = supplier?.id ?? null;
      },

      selectAttribute(attr) {
        if (!attr) {
          this.items.attribute = null;
          this.items.attribute_values = [];
          this.selected_attribute_values = [];
          return;
        }
        this.handleAttributeSelect(attr);
      },

      isAttributeValueSelected(id) {
        return (this.items.attribute_values || [])
          .map(Number)
          .includes(Number(id));
      },

      toggleAttributeValue(val) {
        const id = Number(val.id);
        const current = (this.items.attribute_values || []).map(Number);
        if (current.includes(id)) {
          this.items.attribute_values = current.filter((x) => x !== id);
        } else {
          this.items.attribute_values = [...current, id];
        }
      },

      triggerFetchCategoryDetails() {
        // Trigger fetchCategoryDetails in the child component when modal is clicked
        this.$refs.createSubCategoryModal.fetchCategoryDetails(this.items.category);
      },

      async fetchCatSubCategories(categoryACCId,newSubCategory_id = null) {
        try {
          const response = await this.$axios.get(`${apiUrls.sub_categories.get}`, {
            params: { category_id: categoryACCId }  
          });
          this.selected_cats_sub_categories = response.data;
          if (newSubCategory_id) {
            this.items.sub_category = newSubCategory_id;
          }
        } catch (error) {

        }
      },

      imageUpload(event) {
        const files = event.target.files;

        const allowedTypes = [
          'image/jpeg',
          'image/png',
          'image/webp'
        ];

        if (files && files.length > 0) {
          if (this.items.images.length + files.length > 2) {
            this.toast.error(this.$t('error.max_images'));
            return;
          }

          for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // frontend validation
            if (!allowedTypes.includes(file.type)) {
              this.toast.error('Only JPG, PNG, and WEBP images are allowed.');
              continue;
            }

            this.items.images.push(file);
            this.imagePreview.push(URL.createObjectURL(file));
          }
        }
      },

      removeImage(index) {
        this.items.images.splice(index, 1);
        this.imagePreview.splice(index, 1);
      },

      prepareItemPayload() {
        const payload = {
          ...this.items,
          variants: this.items.variants || [],
        };

        if (this.isMultiVariant) {
          // Item-level stock/price come from variants; opening stock optional via switch.
          payload.stock_quantity = 0;
          payload.purchase_price = 0;
          payload.selling_price = 0;
          payload.discount = Number(payload.discount || 0);

          if (!payload.with_stock) {
            payload.warehouse = null;
            payload.supplier_name = null;
            payload.manufacturing_date = null;
            payload.expire_date = null;
            payload.item_serial_number = "";
          }

          if (!this.add_variant) {
            payload.variants = [];
          } else {
            payload.variants = (payload.variants || []).map(v => ({
              ...v,
              stock: payload.with_stock ? Number(v.stock || 0) : 0,
              purchase_price: Number(v.purchase_price || 0),
              selling_price: Number(v.selling_price || 0),
              discount: Number(v.discount || 0),
            }));
          }

        } else if (payload.with_stock) {

          payload.stock_quantity = Number(payload.stock_quantity || 0);
          payload.purchase_price = Number(payload.purchase_price || 0);
          payload.selling_price = Number(payload.selling_price || 0);
          payload.discount = Number(payload.discount || 0);

        } else if (this.isWarrantyItemType) {
          // Catalog only — prices/stock enter via batch receive with serials.
          payload.with_stock = false;
          payload.stock_quantity = 0;
          payload.purchase_price = 0;
          payload.selling_price = 0;
          payload.warehouse = null;
          payload.supplier_name = null;
          payload.manufacturing_date = null;
          payload.expire_date = null;
          payload.item_serial_number = "";
          payload.discount = Number(payload.discount || 0);
          delete payload.warranty_period_days;
          if (!this.add_variant) {
            payload.variants = [];
          } else {
            payload.variants = (payload.variants || []).map(v => ({
              ...v,
              stock: 0,
              purchase_price: 0,
              selling_price: Number(v.selling_price || 0),
              discount: Number(v.discount || 0),
            }));
          }
        } else {

          payload.size = payload.size || null;
          payload.color = payload.color || null;
          payload.stock_quantity = 0;
          payload.purchase_price = 0;
          payload.selling_price = 0;
          payload.warehouse = null;
          payload.supplier_name = null;
          payload.manufacturing_date = null;
          payload.expire_date = null;
          payload.item_serial_number = "";
        }

        return payload;
      },

      fieldRequiredMsg(fieldKey) {
        return this.$t('error.field_required', { field: this.$t(fieldKey) });
      },

      fieldGtZeroMsg(fieldKey) {
        return this.$t('error.field_gt_zero', { field: this.$t(fieldKey) });
      },

      validatePayload(payload) {
        this.errors = {};

        const safe = (v) => String(v ?? '').trim();

        if (!safe(payload.item_name)) {
          this.errors.item_name = this.fieldRequiredMsg('item_name');
        }
        if (!safe(payload.item_code)) {
          this.errors.item_code = this.fieldRequiredMsg('item_code');
        }
        if (!payload.category) {
          this.errors.category = this.fieldRequiredMsg('category');
        }
        if (!payload.sub_category) {
          this.errors.sub_category = this.fieldRequiredMsg('sub_category');
        }
        if (!payload.unit) {
          this.errors.unit = this.fieldRequiredMsg('unit');
        }
        if (!safe(payload.barcode_qr_code)) {
          this.errors.barcode_qr_code = this.fieldRequiredMsg('barcode_qr_code');
        }
        const vatSelected = this.vat_groups.some(
          (g) => String(g.id) === String(payload.vat_group)
        );
        if (!vatSelected) {
          this.errors.vat_group = this.fieldRequiredMsg('vat_group');
        }

        if (!this.isMultiVariant && !this.isWarrantyItemType) {
          if (Number(payload.selling_price) <= 0) {
            this.errors.selling_price = this.fieldGtZeroMsg('selling_price');
          }
        }

        const validateVariantRow = (variant, index) => {
          const row = index + 1;
          const barcode = String(variant.barcode || '').trim();
          if (!barcode) {
            this.errors[`variant_barcode_${index}`] = this.$t('error.field_required', {
              field: `${this.$t('barcode')} (#${row})`,
            });
          }
          if (Number(variant.selling_price) <= 0) {
            this.errors[`variant_selling_${index}`] = this.$t('error.field_gt_zero', {
              field: `${this.$t('selling_price')} (#${row})`,
            });
          }
          if (payload.with_stock && !this.isWarrantyItemType) {
            if (Number(variant.stock) <= 0) {
              this.errors[`variant_stock_${index}`] = this.$t('error.field_gt_zero', {
                field: `${this.$t('stock_quantity')} (#${row})`,
              });
            }
            if (Number(variant.purchase_price) <= 0) {
              this.errors[`variant_purchase_${index}`] = this.$t('error.field_required', {
                field: `${this.$t('purchase_price')} (#${row})`,
              });
            }
          }
        };

        if (this.isWarrantyItemType && this.add_variant) {
          if (!(payload.variants || []).length) {
            this.errors.variants = this.$t('error.generate_variants_first');
          }
          (payload.variants || []).forEach(validateVariantRow);
        }

        if (this.isMultiVariant && this.add_variant) {
          if (!(payload.variants || []).length) {
            this.errors.variants = this.$t('error.generate_variants_first');
          }

          (payload.variants || []).forEach(validateVariantRow);

          const variantBarcodes = (payload.variants || [])
            .map((v) => String(v.barcode || '').trim())
            .filter(Boolean);
          const uniqueBarcodes = new Set(variantBarcodes);
          if (uniqueBarcodes.size !== variantBarcodes.length) {
            this.errors.variant_barcode = this.$t('error.duplicate_variant_barcodes');
          }
          if (
            payload.barcode_qr_code &&
            uniqueBarcodes.has(String(payload.barcode_qr_code).trim())
          ) {
            this.errors.variant_barcode = this.$t('error.variant_barcode_matches_item');
          }
        }

        if (payload.with_stock) {
          if (!this.isMultiVariant) {
            if (Number(payload.stock_quantity) <= 0) {
              this.errors.stock_quantity = this.fieldGtZeroMsg('stock_quantity');
            }
            if (Number(payload.purchase_price) <= 0) {
              this.errors.purchase_price = this.fieldRequiredMsg('purchase_price');
            }
          }

          if (!payload.warehouse) {
            this.errors.warehouse = this.fieldRequiredMsg('warehouse');
          }

          if (!payload.supplier_name) {
            this.errors.supplier_name = this.fieldRequiredMsg('supplier_name');
          }
        }

        return Object.keys(this.errors).length === 0;
      },

      async submitItem() {
        const payload = this.prepareItemPayload();

        const isValid = this.validatePayload(payload);
        if (!isValid) {
          const messages = [...new Set(Object.values(this.errors).filter(Boolean))];
          this.toast.error(
            messages.length
              ? messages.join('\n')
              : this.$t('error.required'),
            { bodyClassName: 'toast-multiline' }
          );
          return;
        }

        try {
          const formData = new FormData();

          Object.keys(payload).forEach((key) => {
            if (key === 'images' && Array.isArray(payload.images)) {
              payload.images.forEach(img => formData.append('images', img));
            } else if (key !== 'variants') {
              if (
                payload[key] === null ||
                payload[key] === undefined ||
                payload[key] === ''
              ) {
                return;
              }
              formData.append(key, payload[key]);
            }
          });

          const variants = payload.variants || [];
          formData.append("variants", JSON.stringify(
            variants.map(({ image_file, image_preview, ...variant }) => variant)
          ));
          // Matched to variants by row index on the server.
          variants.forEach((variant, index) => {
            if (variant.image_file) formData.append(`variant_image_${index}`, variant.image_file);
          });

          // Send API request
          const response = await this.$axios.post(apiUrls.item.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.toast.success("Item Successfully Created!");

          // Redirect only after successful response
          this.$router.push('/items');

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
          const data = error.response?.data;
          // Non-JSON responses (e.g. a server error HTML page) are not field errors
          if (!data || typeof data !== 'object') {
            this.toast.error('Something went wrong');
            return;
          }

          const messages = [];
          Object.keys(data).forEach((key) => {
            const val = data[key];
            if (Array.isArray(val)) {
              val.forEach((msg) => {
                if (msg) messages.push(String(msg));
              });
            } else if (typeof val === 'string' && val.trim()) {
              messages.push(val);
            }
          });

          const uniqueMessages = [...new Set(messages)];
          if (uniqueMessages.length) {
            this.toast.error(uniqueMessages.join('\n'), {
              bodyClassName: 'toast-multiline',
            });
          } else {
            this.toast.error('Something went wrong');
          }
        }
      },

      cancelForm() {
        this.$router.push('/items');
      },

      removeVariantGroup(index) {
        this.variant_groups.splice(index, 1);

        // Clear generated variants when a group is removed
        this.items.variants = [];
      },

      resetForm() {
        // Reset form fields and errors
        this.items = {
          item_code: '', item_name: '', sku: '', category: '', sub_category: '', size: '', color: '', model_number: '',
          warehouse: '', stock_quantity: '', unit: '', reorder_level: '', manufacturing_date: '', expire_date: '',
          item_serial_number: '', barcode_qr_code: '', supplier_name: '', purchase_price: '', selling_price: 0,
          discount: '', vat_group: null, images: '', item_type: '', attribute: null, attribute_values: [],
        };
        this.imagePreview = [];
        this.variant_groups = [];
        this.items.variants = [];
        this.add_variant = false;
        this.errors = {};
      },

      handleEnter(e) {
        // allow textarea enter
        if (e.target.tagName.toLowerCase() === 'textarea') {
          return;
        }

        e.preventDefault();
      },

    },

};
</script>

<style scoped>
.variant-attr-row {
  background: #f5f8ff;
  border: 1px solid #e0e7ff;
  border-radius: 8px;
  padding: 16px 12px 4px;
  margin-left: 0;
  margin-right: 0;
}

.variant-generate-row {
  margin-left: 0;
  margin-right: 0;
  padding-left: 12px;
  padding-right: 12px;
}

.generated-variants-panel {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e8edf5;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}

.generated-variants-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 52px;
  padding: 12px 16px;
  background: linear-gradient(180deg, #f8faff 0%, #f3f6fc 100%);
  border-bottom: 1px solid #e8edf5;
}

.generated-variants-header h6 {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  letter-spacing: 0.01em;
}

.generated-variants-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 12px;
  font-weight: 600;
}

.generated-variants-table-wrap {
  width: 100%;
  height: 320px;
  overflow: auto;
  background: #ffffff;
}

.generated-variants-table {
  table-layout: fixed;
  width: 100%;
  min-width: 960px;
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
}

.generated-variants-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fafbfd;
  color: #6b7280;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  border: none;
  border-bottom: 1px solid #eef2f7;
  box-shadow: none;
}

.generated-variants-table tbody tr {
  transition: background-color 0.15s ease;
}

.generated-variants-table tbody tr:hover {
  background: #f9fbff;
}

.generated-variants-table th,
.generated-variants-table td {
  vertical-align: middle;
  padding: 10px 12px;
  font-size: 13px;
  color: #374151;
  border: none;
  border-bottom: 1px solid #f1f5f9;
}

.generated-variants-table th:nth-child(1),
.generated-variants-table td:nth-child(1) { width: 13%; }
.generated-variants-table th:nth-child(2),
.generated-variants-table td:nth-child(2) { width: 13%; }
.generated-variants-table th:nth-child(3),
.generated-variants-table td:nth-child(3) { width: 17%; }
.generated-variants-table th:nth-child(4),
.generated-variants-table td:nth-child(4) { width: 13%; }
.generated-variants-table th:nth-child(5),
.generated-variants-table td:nth-child(5) { width: 8%; }
.generated-variants-table th:nth-child(6),
.generated-variants-table td:nth-child(6) { width: 10%; }
.generated-variants-table th:nth-child(7),
.generated-variants-table td:nth-child(7) { width: 10%; }
.generated-variants-table th:nth-child(8),
.generated-variants-table td:nth-child(8) { width: 8%; }
.generated-variants-table th:nth-child(9),
.generated-variants-table td:nth-child(9) { width: 8%; }

.generated-variants-table .variant-input {
  height: 34px;
  min-height: 34px;
  padding: 6px 10px;
  font-size: 13px;
  line-height: 1.2;
  color: #111827;
  background: #f8fafc;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  box-shadow: none;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}

.generated-variants-table .variant-input:hover {
  background: #ffffff;
  border-color: #d5deea;
}

.generated-variants-table .variant-input:focus {
  background: #ffffff;
  border-color: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.18);
  outline: none;
}

/* Hide number input spinner arrows */
.generated-variants-table .variant-input-number::-webkit-outer-spin-button,
.generated-variants-table .variant-input-number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.generated-variants-table .variant-input-number {
  -moz-appearance: textfield;
  appearance: textfield;
}

.generated-variants-table .cell-ellipsis {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #1f2937;
  font-weight: 500;
}

.generated-variants-empty {
  height: 268px;
  text-align: center;
  vertical-align: middle !important;
  color: #9ca3af;
  background: #fcfcfd;
  font-size: 13px;
  border-bottom: none !important;
}

.variant-value-badge {
  display: inline-flex;
  align-items: center;
  background: #eff4ff;
  color: #1849a9;
  border: 1px solid #c6d7fe;
  border-radius: 4px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
  max-width: 100%;
}

.form-basic-dropdown > .btn {
  gap: 0.5rem;
  min-height: 36px;
}

.form-basic-dropdown > .btn .ti {
  color: #000;
}

.attribute-values-dropdown > .btn {
  color: #495057;
}

.attribute-values-dropdown > .btn .text-truncate {
  color: #495057;
}

.attribute-values-dropdown .dropdown-item.active,
.attribute-values-dropdown .dropdown-item.active span {
  color: #495057 !important;
}

.warranty-add-variant-toggle {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #fff8e6;
  border: 1px solid #f0d48a;
  border-left: 4px solid #fe9f43;
  border-radius: 8px;
  padding: 10px 14px;
}

.warranty-add-variant-toggle .form-check-label {
  font-size: 14px;
  font-weight: 700;
  color: #5c4a1f;
  white-space: nowrap;
}

.warranty-add-variant-toggle .form-check-input {
  width: 2.25rem;
  height: 1.15rem;
  margin-top: 0;
  cursor: pointer;
}

.warranty-add-variant-state {
  min-width: 36px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
}

.warranty-add-variant-state.is-yes {
  color: #198754;
}

.warranty-add-variant-state.is-no {
  color: #b45309;
}

.create-item-page-header {
  margin-bottom: 8px !important;
  min-height: 0;
  padding: 0;
  gap: 8px;
}

.create-item-page-header .page-title h4 {
  margin-bottom: 0;
  font-size: 18px;
  line-height: 1.2;
}

.create-item-header-actions {
  margin-bottom: 0;
  gap: 8px !important;
  min-height: 0 !important;
}

.create-item-header-actions > li {
  margin-right: 4px !important;
  margin-bottom: 0;
}

.create-item-header-actions .page-btn {
  margin-left: 0;
  margin-top: 0 !important;
}

.stock-fields-panel {
  margin-top: 8px;
  background: linear-gradient(180deg, #fffaf3 0%, #ffffff 55%);
  border: 1px solid #f0d48a;
  border-left: 4px solid #fe9f43;
  border-radius: 10px;
  overflow: hidden;
}

.stock-fields-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: #fff3e0;
  border-bottom: 1px solid transparent;
}

.optional-panel-header {
  flex-wrap: wrap;
  row-gap: 8px;
}

.optional-panel-controls {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.optional-panel-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid #f0d48a;
  color: #9a6700;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  line-height: 1.3;
}

.optional-panel-hint {
  flex: 1 1 220px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #f0d48a;
  color: #5c4a1f;
  font-size: 12.5px;
  font-weight: 500;
  line-height: 1.45;
}

.optional-panel-hint .ti {
  flex-shrink: 0;
  margin-top: 1px;
  font-size: 15px;
  color: #fe9f43;
}

.optional-panel-hint strong {
  font-weight: 700;
  color: #9a3412;
  white-space: nowrap;
}

.stock-fields-panel.is-open .stock-fields-panel-header {
  border-bottom-color: #f0d48a;
}

.stock-fields-panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #5c4a1f;
}

.stock-fields-panel-title .ti {
  font-size: 18px;
  color: #fe9f43;
}

.stock-fields-panel-header .form-check-input {
  width: 2.25rem;
  height: 1.15rem;
  margin-top: 0;
  cursor: pointer;
}

.stock-fields-panel-body {
  padding: 14px 16px 4px;
}

/* Item Type control in page header */
.item-type-control {
  list-style: none;
}

.item-type-control-inner {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px 6px 12px;
  background: linear-gradient(135deg, #fff8ee 0%, #fff3e0 100%);
  border: 1px solid #f0d48a;
  border-left: 4px solid #fe9f43;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(254, 159, 67, 0.12);
}

.item-type-control-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #9a3412;
  white-space: nowrap;
  line-height: 1;
}

.item-type-control-label .ti {
  font-size: 16px;
  color: #fe9f43;
}

.item-type-wrapper {
  min-width: 190px;
  max-width: 240px;
  height: auto;
}

.item-type-wrapper .form-basic-dropdown > a.btn.item-type-select-btn {
  height: 34px !important;
  min-height: 34px !important;
  width: 100% !important;
  min-width: 190px;
  padding: 4px 12px !important;
  font-size: 13px;
  font-weight: 700;
  color: #5c4a1f !important;
  background: #ffffff !important;
  border: 1px solid #f0d48a !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  justify-content: flex-start !important;
}

.item-type-wrapper .form-basic-dropdown > a.btn.item-type-select-btn .ti {
  color: #fe9f43;
  font-size: 14px;
}

.item-type-wrapper .form-basic-dropdown .dropdown-item {
  height: auto !important;
  width: 100% !important;
  display: block !important;
  justify-content: flex-start !important;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 500;
  padding: 7px 10px;
  color: #5c4a1f;
}

.item-type-wrapper .form-basic-dropdown .dropdown-item.active,
.item-type-wrapper .form-basic-dropdown .dropdown-item:hover {
  background: #fff3e0 !important;
  color: #9a3412 !important;
}
</style>

